(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-actions"] && !Shopify.designMode) return;
  try {
    /**
   * Handles scroll-based behavior for buy-cta-wrapper on mobile
   * Adds .scrolled class when scroll threshold is reached
   */
  (() => {
    const SCROLL_THRESHOLD = 400; // Scroll height in pixels before transformation
    const MOBILE_BREAKPOINT = 749; // Match CSS breakpoint

    const buyCtaWrapper = document.querySelector('.buy-cta-wrapper');
    if (!buyCtaWrapper) return;

    const handleScroll = () => {
      // Only apply on mobile
      if (window.innerWidth > MOBILE_BREAKPOINT) {
        buyCtaWrapper.classList.remove('scrolled');
        return;
      }

      const scrollTop = document.scrollingElement?.scrollTop ?? window.scrollY ?? 0;
      const shouldScroll = scrollTop > SCROLL_THRESHOLD;

      buyCtaWrapper.classList.toggle('scrolled', shouldScroll);
    };

    // Throttle scroll events for performance
    let ticking = false;
    const throttledHandleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    };

    // Initial check
    handleScroll();

    // Listen to scroll events
    window.addEventListener('scroll', throttledHandleScroll, { passive: true });
    window.addEventListener('resize', handleScroll, { passive: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    /**
   * Handles cart button click in header drawer
   * Opens the cart drawer and closes the header drawer
   */
  (() => {
    const cartButton = document.querySelector('[data-testid="header-drawer-cart-button"]');
    if (!cartButton) return;

    cartButton.addEventListener('click', () => {
      // Find the cart drawer component
      const cartDrawer = document.querySelector('cart-drawer-component');
      if (cartDrawer && typeof cartDrawer.open === 'function') {
        // Close the header drawer first
        const headerDrawer = cartButton.closest('header-drawer');
        if (headerDrawer) {
          const details = headerDrawer.querySelector('details[ref="details"]');
          if (details && details.open) {
            details.removeAttribute('open');
          }
        }
        
        // Open the cart drawer
        cartDrawer.open();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sahc-circle-details"] && !Shopify.designMode) return;
  try {
    (function() {
    function positionDotsOnCircle() {
      const circleContainers = document.querySelectorAll('.sahc-dc__details');
      
      circleContainers.forEach(container => {
        const dots = container.querySelectorAll('.sahc-dc__dot');
        const circleWidth = container.offsetWidth;
        
        // Skip if circle hasn't rendered yet
        if (circleWidth === 0) {
          return;
        }
        
        const radius = circleWidth / 2;
        
        dots.forEach(dot => {
          // Get angle from CSS custom property
          const angleValue = getComputedStyle(dot).getPropertyValue('--angle').trim();
          // Extract numeric value (remove 'deg' if present)
          const angleDeg = parseFloat(angleValue) || 0;
          const angleRad = (angleDeg * Math.PI) / 180;
          
          // Calculate position on circumference
          const x = radius * Math.cos(angleRad);
          const y = radius * Math.sin(angleRad);
          
          // Position dot (accounting for dot's own size to center it)
          dot.style.left = `calc(50% + ${x}px)`;
          dot.style.top = `calc(50% + ${y}px)`;
          dot.style.transform = 'translate(-50%, -50%)';
        });
      });
    }
    
    // Run on page load - use requestAnimationFrame to ensure layout is calculated
    function initPositioning() {
      requestAnimationFrame(() => {
        requestAnimationFrame(positionDotsOnCircle);
      });
    }
    
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initPositioning);
    } else {
      initPositioning();
    }
    
    // Recalculate on resize
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(positionDotsOnCircle, 100);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
